import React from 'react'
import PropTypes from 'prop-types'
import ComingSoon from '../components/comingSoon';
import TitleMain from '../components/titleMain';
import CompetitionCard from '../components/competitionCard';
//css
import '../assets/css/competition.css';

//image
import skh from '../assets/img/competition_skh.png';
import ccc from '../assets/img/competition_ccc.png';
import there from '../assets/img/比赛3.jpg';
import four from '../assets/img/比赛4.jpg';
import five from '../assets/img/图片5.png';
import six from '../assets/img/比赛6.png';


class Competition extends React.Component {
  render () {
    return(
      <div>
        <TitleMain name='赛事' />
        <div className='Competition'>
          <div className='Competition__competitionCard'>
            <CompetitionCard title='「森林小英雄」' subtitle={'AI 机械人救援大挑战'} img={six} link='https://airrc.plkflpy.edu.hk/' date={'Apr. 5, 2025 香港城市大学'}/>
          </div>
          <div className='Competition__competitionCard'>
            <CompetitionCard title='「城市救援」-新加坡站' subtitle={'亚太区STEM/AI科技创新挑战赛 InnoBot'} img={four} link='https://gba.cocorobo.hk/' date={'May. 10, 2025 新加坡科技设计大学'}/>
          </div>
          <div className='Competition__competitionCard'>
            <CompetitionCard title='「城市自然灾害防护及救援」' subtitle={'粤港澳大湾区科技创新赛 InnoBot'} img={there} link='https://gba.cocorobo.hk/' date={'Jul. 4, 2025'}/>
          </div>
          <div className='Competition__competitionCard'>
            <CompetitionCard title='「城市救援」-香港站' subtitle={'亚太区STEM/AI科技创新挑战赛 InnoBot'} img={five} link='https://gba.cocorobo.hk/' date={'Jul. 12 2025 香港科学园'}/>
          </div>
          <div className='Competition__competitionCard'>
            <CompetitionCard title='「夺宝奇兵」' subtitle={'圣公会中学3D打印机器人对抗赛'} img={skh} link='http://skh.3dprobot.org' date={'Jul. 23 2018'}/>
          </div>
          <div className='Competition__competitionCard'>
            <CompetitionCard title='「第一届机器人对抗赛」' subtitle={'中华基督教会协和小学 (长沙湾)'} img={ccc} link='http://ccc.3dprobot.org' date={'Feb 1 2019'}/>
          </div>
        </div>
      </div>
    )
  }
}

export default Competition;
